import { useLocation } from 'react-router-dom'
import { DefaultRoute } from '../router/routes'
import moment from 'moment'
// ** Checks if an object is empty (returns boolean)
export const isObjEmpty = (obj) => Object.keys(obj).length === 0

// ** Returns K format from a number
export const kFormatter = (num) =>
  num > 999 ? `${(num / 1000).toFixed(1)}k` : num

// ** Converts HTML to string
export const htmlToString = (html) => html.replace(/<\/?[^>]+(>|$)/g, '')

// ** Checks if the passed date is today
const isToday = (date) => {
  const today = new Date()
  return (
    /* eslint-disable operator-linebreak */
    date.getDate() === today.getDate() &&
    date.getMonth() === today.getMonth() &&
    date.getFullYear() === today.getFullYear()
    /* eslint-enable */
  )
}

/**
 ** Format and return date in Humanize format
 ** Intl docs: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/DateTimeFormat/format
 ** Intl Constructor: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/DateTimeFormat/DateTimeFormat
 * @param {String} value date to format
 * @param {Object} formatting Intl object to format with
 */
export const formatDate = (
  value,
  formatting = { month: '2-digit', day: '2-digit', year: 'numeric' }
) => {
  if (!value) return value
  return new Intl.DateTimeFormat('fr-CA', formatting).format(new Date(value))
}

/**
 * Formats a date into "dd-mm-yyyy" format.
 *
 * @param {string | number | Date} value - The date value to format.
 * @returns {string | undefined} - The formatted date or the original value if invalid.
 */
export function formatDateDDMMYYYY(value) {
  if (!value) return

  const date = new Date(value)
  if (isNaN(date.getTime())) return

  const day = String(date.getDate()).padStart(2, '0')
  const month = String(date.getMonth() + 1).padStart(2, '0')
  const year = date.getFullYear()

  return `${day}-${month}-${year}`
}

const now = new Date()

export function getPastDate(daysCount) {
  return formatDate(
    new Date(now.getFullYear(), now.getMonth(), now.getDate() - daysCount)
  )
}

export function useQueryParams() {
  const { search } = useLocation()
  const queryParams = new URLSearchParams(search)

  const params = {}
  for (let [key, value] of queryParams.entries()) {
    params[key] = value
  }
  return params
}

export const convertDMYTime = (dateTime) => {
  if (!dateTime) {
    return ''
  }

  const months = [
    'Jan',
    'Feb',
    'Mar',
    'Apr',
    'May',
    'Jun',
    'Jul',
    'Aug',
    'Sep',
    'Oct',
    'Nov',
    'Dec'
  ]

  const dateParts = dateTime.split(' ')
  const datePart = dateParts[0]
  const timePart = dateParts[1]

  const dateComponents = datePart.split('-')
  const year = dateComponents[0]
  const month = months[parseInt(dateComponents[1]) - 1]
  const day = dateComponents[2]

  // Split the time into hours, minutes, and seconds
  const timeComponents = timePart.split(':')
  const hours = parseInt(timeComponents[0])
  const minutes = timeComponents[1]

  // Determine if it's AM or PM
  const amPm = hours >= 12 ? 'PM' : 'AM'

  // Convert hours to 12-hour format
  const formattedHours = hours % 12 || 12

  return `${day} ${month} ${year} ${formattedHours}:${minutes} ${amPm}`
}

export const convertDMY = (date) => {
  if (!date) {
    return ''
  }

  const months = [
    'Jan',
    'Feb',
    'Mar',
    'Apr',
    'May',
    'Jun',
    'Jul',
    'Aug',
    'Sep',
    'Oct',
    'Nov',
    'Dec'
  ]

  // const dateParts = date.split('-')
  // const year = dateParts[0]
  // const month = months[parseInt(dateParts[1]) - 1]
  // const day = dateParts[2]

  const dateOnly = date.split(' ')[0]
  const [year, monthNum, day] = dateOnly.split('-')
  const month = months[parseInt(monthNum, 10) - 1]

  return `${day} ${month} ${year}`
}
export function getTomorrowDate() {
  // debugger
  const today = new Date()
  const tomorrow = new Date(today)
  tomorrow.setDate(tomorrow.getDate() + 1)
  return formatDate(tomorrow)
}

export function getBackDayDate() {
  // debugger
  const today = new Date()
  const backDate = new Date(today)
  backDate.setDate(today.getDate() - 6)

  return formatDate(backDate)
}

// export function getMinEndDate(daysCount) {
//   return formatDate(
//     new Date(now.getFullYear(), now.getMonth(), now.getDate() + daysCount)
//   )
// }

// ** Returns short month of passed date
export const formatDateToMonthShort = (value, toTimeForCurrentDay = true) => {
  const date = new Date(value)
  let formatting = { month: 'short', day: 'numeric' }

  if (toTimeForCurrentDay && isToday(date)) {
    formatting = { hour: 'numeric', minute: 'numeric' }
  }

  return new Intl.DateTimeFormat('en-US', formatting).format(new Date(value))
}

/**
 ** Return if user is logged in
 ** This is completely up to you and how you want to store the token in your frontend application
 *  ? e.g. If you are using cookies to store the application please update this function
 */
export const isUserLoggedIn = () =>
  localStorage.getItem('userData') && localStorage.getItem('accessToken')
export const getUserData = () => JSON.parse(localStorage.getItem('userData'))
export const URLRegex =
  /(https?:\/\/(?:www\.|(?!www))[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]\.[^\s]{2,}|www\.[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]\.[^\s]{2,}|https?:\/\/(?:www\.|(?!www))[a-zA-Z0-9]+\.[^\s]{2,}|www\.[a-zA-Z0-9]+\.[^\s]{2,})/gi
export const emailRegex = /^\S+@\S+\.\S+$/
export const passwordRegex =
  /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#\$%\^&\*])(?=.{8,16})/
export const phoneRegex = /^([+]\d{2})?\d{10}$/
export const numRegex = /^([1-9]|[1-9][0-9]|100)$/
export const yearsRegex = /^([0-9]|1[0-9]|20)$/
export const monthsRegex = /^([0-9]|1[012])$/
export const maxDate = new Date().toISOString().split('T')[0]
export const maxStartDate = new Date(
  new Date().getFullYear(),
  new Date().getMonth(),
  new Date().getDate() - 0
)
  .toISOString()
  .split('T')[0]

export const minEndDate = (startDate) => {
  const currentDate = new Date(startDate)
  currentDate.setDate(currentDate.getDate() + 1)

  return formatDate(
    currentDate.toLocaleDateString('en-US', {
      year: 'numeric',
      month: '2-digit',
      day: '2-digit'
    })
  )
}

/**
 ** This function is used for demo purpose route navigation
 ** In real app you won't need this function because your app will navigate to same route for each users regardless of ability
 ** Please note role field is just for showing purpose it's not used by anything in frontend
 ** We are checking role just for ease
 * ? NOTE: If you have different pages to navigate based on user ability then this function can be useful. However, you need to update it.
 * @param {String} userRole Role of user
 */
export const getHomeRouteForLoggedInUser = (userRole) => {
  if (userRole === 'admin') return DefaultRoute
  return '/login'
  return DefaultRoute
}

export const hasPermission = (temp) => {
  const data = JSON.parse(window.localStorage.getItem('userData'))?.permissions
  return data ? data.includes(temp) : false
}

// ** React Select Theme Colors
export const selectThemeColors = (theme) => ({
  ...theme,
  colors: {
    ...theme.colors,
    primary25: '#7367f01a', // for option hover bg-color
    primary: '#7367f0', // for selected option bg-color
    neutral10: '#7367f0', // for tags bg-color
    neutral20: '#ededed', // for input border-color
    neutral30: '#ededed' // for input hover border-color
  }
})

export const customStyles = {
  cells: {
    style: {
      width: '150px',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      // whiteSpace: 'nowrap'
      minHeight: '70px'
    }
  }
}
export const getDateRange = (reviewDateStr) => {
  const today = moment().startOf('day')
  const reviewDate = moment(reviewDateStr).startOf('day')

  let minDate, maxDate

  if (reviewDate.isAfter(today)) {
    minDate = today
    maxDate = reviewDate.clone().add(3, 'days').endOf('days')
  } else if (reviewDate.isSame(today)) {
    minDate = today
    maxDate = today.clone().add(3, 'days').endOf('days')
  } else {
    minDate = reviewDate
    maxDate = reviewDate.clone().add(3, 'days').endOf('days')
  }

  return {
    minDate: minDate.format('YYYY-MM-DDTHH:mm'),
    maxDate: maxDate.format('YYYY-MM-DDTHH:mm')
  }
}
export const customViewLogsStyles = {
  cells: {
    style: {
      width: '150px',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      // whiteSpace: 'nowrap'
      minHeight: '35px',
      paddingTop: ' 0rem',
      paddingBottom: '0rem',
      paddingRight: '0.5rem',
      paddingLeft: '0.5rem'
    }
  },
  rows: {
    style: {
      // whiteSpace: 'nowrap'
      paddingTop: ' 0rem',
      paddingBottom: '0rem',
      paddingRight: '0.5rem'
      //paddingLeft: '0.5rem'
    }
  }
}

export const customReviewsStyles = {
  cells: {
    style: {
      width: '150px',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      // whiteSpace: 'nowrap'
      minHeight: '35px',
      paddingTop: ' 0rem',
      paddingBottom: '0rem',
      paddingRight: '0.5rem',
      paddingLeft: '0.5rem'
    }
  },
  rows: {
    style: {
      // whiteSpace: 'nowrap'
      paddingTop: ' 0rem',
      paddingBottom: '0rem',
      paddingRight: '0.5rem',
      paddingLeft: '0.5rem'
    }
  }
}

export const Rating = [
  { label: '1', value: '1' },
  { label: '1.25', value: '1.25' },
  { label: '1.5', value: '1.5' },
  { label: '1.75', value: '1.75' },
  { label: '2', value: '2' },
  { label: '2.25', value: '2.25' },
  { label: '2.5', value: '2.5' },
  { label: '2.75', value: '2.75' },
  { label: '3', value: '3' },
  { label: '3.25', value: '3.25' },
  { label: '3.5', value: '3.5' },
  { label: '3.75', value: '3.75' },
  { label: '4', value: '4' },
  { label: '4.25', value: '4.25' },
  { label: '4.5', value: '4.5' },
  { label: '4.75', value: '4.75' },
  { label: '5', value: '5' }
]

export const PriorityOptions = [
  { label: '1', value: '1' },
  { label: '2', value: '2' },
  { label: '3', value: '3' },
  { label: '4', value: '4' },
  { label: '5', value: '5' },
  { label: '6', value: '6' },
  { label: '7', value: '7' },
  { label: '8', value: '8' },
  { label: '9', value: '9' },
  { label: '10', value: '10' }
]

export const statusName = [
  {
    label: 'Training Completed',
    value: 0
  },
  {
    label: 'Ready To Deploy',
    value: 1
  },
  {
    label: 'Under Training',
    value: 2
  },
  {
    label: 'Deployed',
    value: 3
  },
  {
    label: 'Freeze',
    value: 5
  }
]
export const status = [
  {
    label: 'Pending',
    value: 0
  },
  {
    label: 'Reviewed',
    value: 1
  },
  {
    label: 'Rescheduled',
    value: 2
  },
  {
    label: 'Canceled',
    value: 3
  }
]

// maxLength of input

export const maxLength = 100
export const minLength = 2
export const descriptionMaxLength = 500
export const descriptionMinLength = 3
export const AddressMaxLength = 50
export const AddressMinLength = 3
export const mobileLength = 10
export const tooShort = 'User Name too short'
export const alphabetOnly = /^[a-zA-Z-]+$/
export const alphabetOnlyMsg = 'alphabets only required'
export const alphabet_symbols = /^[a-zA-Z&-'.]+$/
export const alphabetOnlyOneSpace = /^([A-Za-z]+\s?)*\s*$/
const alphabet_specialChar = /^[a-zA-Z_!@#$%^&*()]+$/
export const mobileNumberWithBackSpace = /^[0-9\b]{0,10}$/
// *** custom common functions

function hasNonNumericValuesAndSpace(arr) {
  return arr.some((element) => isNaN(element) || element === ' ')
}

function hasConsecutiveEmptyStrings(arr, fieldType) {
  if (fieldType === 'email') {
    return arr.split('').includes(' ') ? true : false
  } else {
    const lastTwoElements = arr.slice(-2)
    return lastTwoElements[0] === ' ' && lastTwoElements[1] === ' '
  }
}

export const handleInputSpecialCharaters = (
  e,
  setValue,
  fieldName,
  setError,
  clearErrors
) => {
  const inputWithSpace = [
    'name',
    'roleName',
    'topicname',
    'subTopicName',
    'taskName',
    'technologyId',
    'categoryName',
    'moduleName',
    'projectName',
    'projectManegerName',
    'technologyName'
  ]
  const emailCheck = ['email']

  if (inputWithSpace.includes(fieldName)) {
    const inputField = e.target.value.split('')
    const filteredInputValue = inputField
      .filter((item) => alphabetOnlyOneSpace.test(item))
      .join('')
    if (hasConsecutiveEmptyStrings(filteredInputValue)) {
      setError(fieldName, {
        type: 'manual',
        message: 'only single space are allowed'
      })
    } else {
      setValue(fieldName, filteredInputValue)
      clearErrors(fieldName)
    }
  } else if (emailCheck.includes(fieldName)) {
    const inputField = e.target?.value
    hasConsecutiveEmptyStrings(inputField)
    if (hasConsecutiveEmptyStrings(inputField, 'email')) {
      setError('email', {
        type: 'manual',
        message: 'no space are allowed in email'
      })
    } else {
      setValue(fieldName, e.target.value)
      clearErrors(fieldName)
    }
  }
}

export const preventMobileInput = (e, type) => {
  if ((type = 'preventInputValue')) {
    return ['e', 'E', '+', '-', '.'].includes(e.key) && e.preventDefault()
  }
}

export const bodyHtml = `<p><span style=\"font-size: 1.1em;font-family: Helvetica, Arial, sans-serif;\">Hi,</span>&nbsp;</p>\r\n<p><span style=\"font-family: Helvetica, Arial, sans-serif;\">Dear NAME, </span><br><br><span style=\"font-family: Helvetica, Arial, sans-serif;\">I am writing to inform you that a Performance Improvement Plan (PIP) has been initiated for you. The purpose of this PIP is to address certain areas of your job performance that need improvement and to help you succeed in your role.</span><br><br><span style=\"font-family: Helvetica, Arial, sans-serif;\">Your performance has been carefully evaluated and has not been found to be satisfactory in the past few days.</span></p>\r\n<h4 style=\"margin-left:auto;\"><span style=\"color: rgb(255,255,255);background-color: rgb(0,70,106);font-family: Helvetica, Arial, sans-serif;\">Your performance will be closely monitored for 15 days i.e. till DATE.</span><br><br><span style=\"font-family: Helvetica, Arial, sans-serif;\">It is important that your performance meets the expectations of your role and the company. We are committed to supporting your success and encourage you to reach out if you have any questions or need additional support.</span><br><br><span style=\"font-family: Helvetica, Arial, sans-serif;\">We expect to see improvement in your performance.</span></h4>\r\n<p>&nbsp;</p>\r\n<p><span style=\"font-size: 0.9em;font-family: Helvetica, Arial, sans-serif;\">This is an auto-generated email. Please do not reply.</span>&nbsp;</p>`

export const toTiltleCase = (value) => {
  if (!value || typeof value !== 'string') return value || '-'
  let arr = value.toLowerCase().split(/[_ ]+/)

  const newWord = arr
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(' ')
  return newWord
}

export const firstLetterCapital = (value) => {
  if (!value) return value
  return value[0].toUpperCase() + value.slice(1).toLowerCase()
}

// cvLinks may come as an array (of strings or objects), a JSON array string
// or a comma separated string
export const parseCvLinks = (cvLinks) => {
  let list = cvLinks
  if (typeof list === 'string') {
    try {
      list = JSON.parse(list)
    } catch {
      list = list.split(',')
    }
  }
  if (!Array.isArray(list)) return []
  return list
    .map((cv) =>
      typeof cv === 'string' ? cv : cv?.cvLink || cv?.link || cv?.url
    )
    .map((link) => link?.trim())
    .filter(Boolean)
}

export const getCvLinkHref = (link) =>
  link.startsWith('http') ? link : `https://${link}`
